import { object, string, number } from 'yup';
import i18n from '../../../i18n';

// Types
import { BudgetItemManagement } from './types';

export const BudgetItemManagementSchema = object<BudgetItemManagement>({
  code: string()
    .required(() => i18n.t('validation:required'))
    .matches(/^\d+$/, () => 'El código debe contener solo números')
    .min(1, () => 'El código debe tener al menos 1 dígito')
    .max(10, () => 'El código no puede tener más de 10 dígitos'),
  description: string()
    .required(() => i18n.t('validation:required'))
    .min(5, () => 'La descripción debe tener al menos 5 caracteres')
    .max(500, () => 'La descripción no puede tener más de 500 caracteres'),
  unit: string()
    .required(() => i18n.t('validation:required'))
    .min(1, () => 'La unidad es obligatoria')
    .max(10, () => 'La unidad no puede tener más de 10 caracteres'),
  unitPrice: number()
    .required(() => i18n.t('validation:required'))
    .min(0, () => 'El precio debe ser mayor o igual a 0')
    .max(999999.99, () => 'El precio no puede ser mayor a 999,999.99'),
  budgetCategoryId: string().required(() => i18n.t('validation:required')),
});

